import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe, NgIf } from '@angular/common';

import { isNil } from 'lodash';

import { OfficeStore } from '@pages/office/store/office.store';
import { ComboBoxItem } from '@pages/office/models/combobox-item.model';
import { OfficeFieldWebInputTypeEnum } from '@pages/office/models/office-data.model';
import { ControlWrapperComponent } from '../control-wrapper/control-wrapper.component';
import { BaseFormControlDirective } from '../base-form-control.directive';
import { ControlHasRequiredPipe } from '../pipes/control-has-required.pipe';
import { ControlTypeEnum } from '../../../../models/control-type.model';
import { isEmptyValue } from '@core/helpers/value-empty-checker.helper';
import { FormHelper } from '../../../../shared/helpers/form.helper';
import { HIDDEN_ITEM_SEQUENCE_ORDER } from '@pages/office/office.constants';

@Component({
  selector: 'app-select',
  templateUrl: 'select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ControlWrapperComponent, ReactiveFormsModule, AsyncPipe, NgIf, ControlHasRequiredPipe],
})
export class SelectComponent extends BaseFormControlDirective implements OnInit {
  public comboBoxItems$ = signal<ComboBoxItem[]>([]);

  readonly controlTypeEnum: typeof ControlTypeEnum = ControlTypeEnum;

  private officeStore = inject(OfficeStore);

  ngOnInit(): void {
    super.ngOnInit();

    let items = this.officeStore.getComboboxBySeq(this.officeField.Seq);

    items = this.removeHiddenItems(items);
    this.sortItemsBySequenceOrder(items);
    this.setDefaultValue(items);
    this.convertValueToString();

    this.comboBoxItems$.set(items);
  }

  private removeHiddenItems(items: ComboBoxItem[]): ComboBoxItem[] {
    return items.filter(item => item.SequenceOrder !== HIDDEN_ITEM_SEQUENCE_ORDER);
  }

  private sortItemsBySequenceOrder(items: ComboBoxItem[]): void {
    items.sort((a, b) => {
      // put null values at the end
      if (a.SequenceOrder === null && b.SequenceOrder === null) return 0;
      if (a.SequenceOrder === null) return 1;
      if (b.SequenceOrder === null) return -1;

      return a.SequenceOrder - b.SequenceOrder;
    });
  }

  private convertValueToString(): void {
    !isNil(this.control.value) && this.control.setValue(String(this.control.value), { emitEvent: false, onlySelf: true });
  }

  private setDefaultValue(items: ComboBoxItem[]): void {
    if (
      this.officeField.WebInputType === OfficeFieldWebInputTypeEnum.radiobutton &&
      isEmptyValue(this.control.value) &&
      FormHelper.hasRequiredValidator(this.control)
    ) {
      const [firstOption] = items;
      this.control.setValue(firstOption.DatabaseValue, { emitEvent: true, onlySelf: true });
      this.control.markAsDirty();
    }
  }
}
